import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { getAllSales } from "../api/salesApi";
import DataTable from "react-data-table-component";
const Washes = () => {

  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  // Check if the current month is December (11)
  const nextMonth = today.getMonth() === 11
    ? new Date(today.getFullYear() + 1, 0, 0)  // If it's December, set endOfMonth to January 0th of next year (which is the last day of December)
    : new Date(today.getFullYear(), today.getMonth() + 1, 0);  // Otherwise, set endOfMonth to the last day of the current month

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Pads month with leading zero
    const day = String(date.getDate()).padStart(2, '0'); // Pads day with leading zero
    return `${year}-${month}-${day}`;
  }

  const [startDate, setStartDate] = useState(formatDate(startOfMonth)); // First day of the current month
  const [endDate, setEndDate] = useState(formatDate(nextMonth)); // Last day of the current month or the end of December

  const [refreshKey, setRefreshKey] = useState(0);

  const handleChangeStart = (e) => {
    setRefreshKey((prev) => prev + 1); setStartDate(e.target.value);

  }
  const handleChangeEnd = (e) => {
    setRefreshKey((prev) => prev + 1); setEndDate(e.target.value);
  }

  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [data, setData] = useState([]); // Initialize as empty array
  const {clientData} = useAuth();

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        setLoading(true);
        setError(null);
        const today = new Date();
        const todayStart =
          startDate ||
          `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
        const todayEnd =
          endDate ||
          `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
        const params = {
          startDate: todayStart,
          endDate: todayEnd,
          client_id: clientData.client_id
        };
   

        const sales = await getAllSales(params);
        setData(sales); // Ensure data is always an array
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, [refreshKey, clientData]);

  const columns = [
    { name: "Sales ID", selector: (row) => row.sales_id, sortable: true },
    {
      name: "Vehicle Info",
      selector: (row) =>
        `${row.vehicle?.model || "N/A"} - ${
          row.vehicle?.plate_number || "N/A"
        }`,
      sortable: true,
    },
    {
      name: "Payment Type",
      selector: (row) => row.payment_type,
      sortable: true,
    },
    { name: "Branch Name", selector: (row) => row?.branch?.name, sortable: true },
    { name: "Action", selector: (row) => row.action, sortable: true },
    { name: "Total", selector: (row) => row.total, sortable: true },
  ];
  const conditionalRowStyles = [
    {
      when: (row) => row.action === "SUBSCRIBE",
      style: {
        backgroundColor: "rgba(63, 195, 128, 0.9)",
        color: "white",
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
    {
      when: (row) => row.action === "WASH",
      style: {
        backgroundColor: "rgba(63, 63, 128, 0.7)",
        color: "white",
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
  ];
  return (
    <div className="flex flex-col items-center justify-start min-h-screen mb-20 pt-6 ">
      <h1 className="text-2xl font-bold">Washes</h1>
      <div className="flex gap-2 flex-wrap sm:flex-nowrap shadow-lg mb-2 p-3 w-full">
        <div className="w-full sm:w-auto">
          <label className="block mb-2 text-blue-600 text-sm font-semibold">Start Date:</label>
          <input
            type="date"
            value={startDate}
            onChange={handleChangeStart}
            className="w-full border p-2 rounded"
          />
        </div>
        <div className="w-full sm:w-auto">
          <label className="block mb-2 text-blue-600 text-sm font-semibold">End Date:</label>
          <input
            type="date"
            value={endDate}
            onChange={handleChangeEnd}
            className="w-full border p-2 rounded"
          />
        </div>
      </div>
      <div className="data-table overflow-x-auto w-full">
         <DataTable
            data={data} // Pass the dataset here
            columns={columns} // Pass the column definitions here
            pagination
            fixedHeader={true}
            fixedHeaderScrollHeight={"500px"}
            conditionalRowStyles={conditionalRowStyles}
          /></div>
    </div>
  );
};

export default Washes;
